export type ContentTocItem = {
  id: string
  text: string
  level: number
}

export const slugifyContentHeading = (text: string) =>
  (text || '')
    .toLowerCase()
    .trim()
    .replace(/<[^>]*>/g, '')
    .replace(/[^\w\u4e00-\u9fa5\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'section'

export const collectContentTocItems = (root: HTMLElement | null): ContentTocItem[] => {
  if (!root) {
    return []
  }
  const usedIds = new Set<string>()
  const slugCount = new Map<string, number>()

  return Array.from(root.querySelectorAll<HTMLElement>('h1, h2, h3, h4'))
    .map(node => {
      const text = String(node.textContent || '').trim()
      const level = Number(node.tagName.slice(1))
      if (!text || !Number.isFinite(level)) {
        return null
      }
      let id = String(node.id || '').trim()
      if (!id) {
        const base = slugifyContentHeading(text)
        let count = (slugCount.get(base) || 0) + 1
        id = count > 1 ? `${base}-${count}` : base
        while (usedIds.has(id)) {
          count += 1
          id = `${base}-${count}`
        }
        slugCount.set(base, count)
        node.id = id
      }
      usedIds.add(id)
      return { id, text, level }
    })
    .filter((item): item is ContentTocItem => Boolean(item))
}
